

/*!
 * enquire.js v2.1.2 - Awesome Media Queries in JavaScript
 * Copyright (c) 2014 Nick Williams - http://wicky.nillia.ms/enquire.js
 * License: MIT (http://www.opensource.org/licenses/mit-license.php)
 */
!function(a,b,c){var d=window.matchMedia;"undefined"!=typeof module&&module.exports?module.exports=c(d):"function"==typeof define&&define.amd?define(function(){return b[a]=c(d)}):b[a]=c(d)}("enquire",this,function(a){"use strict";function b(a,b){var c,d=0,e=a.length;for(d;e>d&&(c=b(a[d],d),c!==!1);d++);}function c(a){return"[object Array]"===Object.prototype.toString.apply(a)}function d(a){return"function"==typeof a}function e(a){this.options=a,!a.deferSetup&&this.setup()}function f(b,c){this.query=b,this.isUnconditional=c,this.handlers=[],this.mql=a(b);var d=this;this.listener=function(a){d.mql=a,d.assess()},this.mql.addListener(this.listener)}function g(){if(!a)throw new Error("matchMedia not present, legacy browsers require a polyfill");this.queries={},this.browserIsIncapable=!a("only all").matches}return e.prototype={setup:function(){this.options.setup&&this.options.setup(),this.initialised=!0},on:function(){!this.initialised&&this.setup(),this.options.match&&this.options.match()},off:function(){this.options.unmatch&&this.options.unmatch()},destroy:function(){this.options.destroy?this.options.destroy():this.off()},equals:function(a){return this.options===a||this.options.match===a}},f.prototype={addHandler:function(a){var b=new e(a);this.handlers.push(b),this.matches()&&b.on()},removeHandler:function(a){var c=this.handlers;b(c,function(b,d){return b.equals(a)?(b.destroy(),!c.splice(d,1)):void 0})},matches:function(){return this.mql.matches||this.isUnconditional},clear:function(){b(this.handlers,function(a){a.destroy()}),this.mql.removeListener(this.listener),this.handlers.length=0},assess:function(){var a=this.matches()?"on":"off";b(this.handlers,function(b){b[a]()})}},g.prototype={register:function(a,e,g){var h=this.queries,i=g&&this.browserIsIncapable;return h[a]||(h[a]=new f(a,i)),d(e)&&(e={match:e}),c(e)||(e=[e]),b(e,function(b){d(b)&&(b={match:b}),h[a].addHandler(b)}),this},unregister:function(a,b){var c=this.queries[a];return c&&(b?c.removeHandler(b):(c.clear(),delete this.queries[a])),this}},new g});
; // This semicolon fixes the 'SyntaxError: Invalid or unexpected token' at line 15


// Removed the old `afterResize` variable here, as it's now integrated directly into `timber.equalHeights`

window.timber = window.timber || {};

// Initialize timber.cache object if it doesn't exist
timber.cache = timber.cache || {};

// --- Add or update timber.cacheVariables ---
timber.cacheVariables = function () {
  timber.vars = {
    bpLarge: 769, // Breakpoint for large screens, adjust if needed
    mediaQueryLarge: 'screen and (min-width: 769px)',
    isLargeBp: false,
    isTouch: $('html').hasClass('supports-touch')
  };
  // Example: Cache your main product image element
  timber.cache.$productImage = $('#productPhotoImg');
  // Example: Cache elements for featured collections if your theme uses them
  timber.cache.$featuredContainer = $('.featured-collection');
  timber.cache.$productGridImages = $('.grid-item .product-grid-image'); // Adjust selector as needed
};




// --- Main initialization block (jQuery document ready) ---
$(function() {
  // Ensure timber.cacheSelectors is called if it exists in your theme, or initialize timber.cache
  if (typeof timber.cacheSelectors === 'function') {
    timber.cacheSelectors();
  } else {
    timber.cache = timber.cache || {}; // Make sure cache object exists
    // You might need to add specific selectors to cache here if not handled by timber.cacheSelectors
  }

  // Always call cacheVariables to set up timber.vars and initial cached selectors
  if (typeof timber.cacheVariables === 'function') {
    timber.cacheVariables();
  }

  // Initialize equalHeights
  if (typeof timber.equalHeights === 'function') {
    timber.equalHeights();
  }

  // Other theme initializations, if any, should go here.
  // For example, if your theme has a `timber.product` function:
  // if (typeof timber.product === 'function') { timber.product(); }
  // if (typeof timber.drawers === 'function') { timber.drawers(); }
});

// Search and replace all remaining instances of `.size()` with `.length`
// (I have done this within the provided code, but if you have other custom JS blocks
// within your Liquid files that are not part of shop.js.liquid, remember to check those too).